import React from 'react'
import update from 'immutability-helper';
import DropzoneComponent from 'react-dropzone-component';

import { user } from '../../core/controllers/user';
import { phoneNumberFormatter } from '../../helpers/General/PhoneNunberFormatter'
import { modal } from '../../core/utilities/modal'
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { documents } from '../../core/controllers/Documents';

const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} class="img-aspect-ratio" width="100%" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class AccountTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user_info: {
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                company: '',
                userType: '',
                companyLogo: null
            },
            newPassword: {
                oldPassword: '',
                newPassword: '',
                repeatPassword: ''
            },
            didGetInfo: false,
            logo: null
        }
    }

    componentDidMount() {
        dropZone.setup(this, 'companylogo', 0);
    }

    componentWillUpdate(nextProps, nextState) {
    }

    handleFirstnameChange(e){
        this.setState({
            user_info: update(this.state.user_info, {
                firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            user_info: update(this.state.user_info, {
                lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleCompanyChange(e){
        this.setState({
            user_info: update(this.state.user_info, {
                company: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            user_info: update(this.state.user_info, {
                phone: {$set: phoneNumber
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            user_info: update(this.state.user_info, {
                email: {$set: e.target.value
                }}
            )
        });
    }

    handleOldPasswordChange(e){
        this.setState({
            newPassword: update(this.state.newPassword, {
                oldPassword: {$set: e.target.value
                }}
            )
        });
    }

    handleNewPasswordChange(e){
        this.setState({
            newPassword: update(this.state.newPassword, {
                newPassword: {$set: e.target.value
                }}
            )
        });
    }

    handleRepeatPasswordChange(e){
        this.setState({
            newPassword: update(this.state.newPassword, {
                repeatPassword: {$set: e.target.value
                }}
            )
        });
    }

    validatePasswordMatch() {
        const newPassword = this.state.newPassword.newPassword;
        const repeatPassword = this.state.newPassword.repeatPassword;

        if((newPassword !== repeatPassword) || (newPassword.length === 0 || repeatPassword.length === 0)) {
            modal.showInfo("Passwords do not match.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    handleResetPassword(e){
        if(!this.validatePasswordMatch()) {
            return;
        }

        user.resetPassword(this.state.newPassword.newPassword);
    }

    handleUpdateAccount(e){
        user.updateUserAccount(this.state.user_info);
    }

    getUserInfo() {
        var self = this;
        user.getUserInfo(function(response) {
            response.data['userType'] = user.userInfo.user_type_alias;
            self.setState({
                user_info: response.data,
                didGetInfo: true
            })
        });
    }

    handleDeleteDocument(type, attachment) {
        var self = this;
        if (type == "profilepic") {
            documents.deleteDocument(attachment.storage_id, function() {
                user.deleteProfilePic(function() {
                    self.getUserInfo();
                });
            });
        } else if (type == "companylogo") {
            documents.deleteDocument(attachment.storage_id, function() {
                user.deleteCompanyLogo(function() {
                    self.getUserInfo();
                });
            });
        }
    }

    renderAttachments(type, attachment) {
        if (attachment != null && attachment != false) {
            return <Attachment attachment={attachment} deleteFunc={this.handleDeleteDocument.bind(this, type, attachment)}/>
        }
        else return (<p style={{textAlign: 'center'}}>You have not uploaded a {type == "profilepic" ? "profile picture." : "company logo."}</p>);
    }

    triggerUpload(type) {
        var self = this;
        if (type == "profilepic") {
            dropZone.overridePostUrl(type, 0);
            dropZone.upload(type, function() {
                self.getUserInfo();
                modal.showInfo("Profile picture successfully uploaded!", "success", "top", "center");
            });
        } else if (type == "companylogo") {
            dropZone.overridePostUrl(type, 0);
            dropZone.upload(type, function() {
                self.getUserInfo();
                modal.showInfo("Company logo successfully uploaded!", "success", "top", "center");
            });
        }
        if (dropZone.isFilesAdded() == false) {
            modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
        }
    }

    render(){
        const user_info = this.state.user_info;
        const userType = user_info.userType;
        const logo = this.renderAttachments("companylogo", this.state.user_info.logo);
        const profilePicture = this.renderAttachments("profilepic", this.state.user_info.profile_picture);
        if(!this.state.didGetInfo) {
            this.getUserInfo();
        }

        var disableCompany = false;
        if (userType == "property-manager") {
            disableCompany = true
        }

        return (
            <div>
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Account Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label>First name</label>
                                    <input type="text" value={user_info.firstname} class="form-control tenant-info" name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label>Last name</label>
                                    <input type="text" value={user_info.lastname} class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" onChange={this.handleLastnameChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="text" value={user_info.email} class="form-control tenant-info" name="email" placeholder="Email" id="email" onChange={this.handleEmailChange.bind(this)} disabled={true}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input type="text" value={user_info.phone} class="form-control tenant-info" name="phone" placeholder="Phone" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            {(userType !== 'tenant' && userType !== 'owner') && (
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label>Company</label>
                                    <input type="text" value={user_info.company} disabled={disableCompany} class="form-control tenant-info" name="company" placeholder="Company" id="company" onChange={this.handleCompanyChange.bind(this)}/>
                                </div>
                            </div>
                            )}
                        </div>
                            <div class="row account-button">
                                <div class="col-md-12 col-sm-12 col-xs-12 account-button-child" style={{float: "left", marginLeft: "15px", marginTop: "10px", marginBottom: "5px"}}>
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateAccount.bind(this)}>
                                Update Account
                                </button>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            { userType != 'vendor' && (
            <div class="col-md-4 col-sm-6 col-xs-12 account-container">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Reset Password</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            {/* <div class="col-md-10">
                                <div class="form-group">
                                    <label>Current Password</label>
                                    <input type="text" value={this.state.newPassword.oldPassword} class="form-control tenant-info" name="phone" placeholder="Phone" id="firstname" onChange={this.handleOldPasswordChange.bind(this)}/>
                                </div>
                            </div> */}
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>New Password</label>
                                    <input type="password" value={this.state.newPassword.newPassword} class="form-control tenant-info" name="newpassword" placeholder="New Password" id="newpassword" onChange={this.handleNewPasswordChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Repeat Password</label>
                                    <input type="password" value={this.state.newPassword.repeatPassword} class="form-control tenant-info" name="repeatnewpassword" placeholder="Repeat New Password" id="repeatnewpassword" onChange={this.handleRepeatPasswordChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                                    <div class="content col-md-12 col-sm-12 col-xs-12 text-center">
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleResetPassword.bind(this)}>
                                Reset Password
                                </button>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            { userType != 'vendor' && (
            <div class="col-md-4 col-sm-6 col-xs-12 account-container-misc">
                 <div class="card">
                     <div class="header">
                         <h4 class="title">Profile Picture</h4>
                         <p class="category"></p>
                     </div>
                     <div class="content">
                        <div class="row">
                            <div class="col-md-12" style={{margin: '10px'}}>
                                <div class="row">
                                    {profilePicture}
                                </div>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-md-12" >
                                { this.state.dropZoneSetup !== undefined && (
                                    <DropzoneComponent config={this.state.dropZoneConfig}
                                        eventHandlers={this.state.dropZoneEventHandlers}
                                        djsConfig={this.state.dropZoneJSConfig} />
                                )}
                            </div>
                         </div>
                         <div class="row">
                                    <div class="content col-md-12 col-sm-12 col-xs-12 text-center" style={{marginTop: "10px"}}>
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.triggerUpload.bind(this, "profilepic")}>
                                Upload
                                </button>
                                <div class="clearfix"></div>
                             </div>
                         </div>
                     </div>
                 </div>
            </div>
            )}
            { userType == 'admin' && (
                    <div class="col-md-4 col-sm-6 col-xs-12 account-container-misc">
                 <div class="card">
                     <div class="header">
                         <h4 class="title">Company Logo</h4>
                         <p class="category"></p>
                     </div>
                     <div class="content">
                        <div class="row">
                            <div class="col-md-12" style={{margin: '10px'}}>
                                <div class="row">
                                    {logo}
                                </div>
                            </div>
                         </div>
                         <div class="row">
                            <div class="col-md-12">
                                { this.state.dropZoneSetup !== undefined && (
                                    <DropzoneComponent config={this.state.dropZoneConfig}
                                        eventHandlers={this.state.dropZoneEventHandlers}
                                        djsConfig={this.state.dropZoneJSConfig} />
                                )}
                            </div>
                         </div>
                         <div class="row">
                            <div class="content col-md-12 col-sm-12 col-xs-12 text-center" style={{marginTop: "10px"}}>
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.triggerUpload.bind(this, "companylogo")}>
                                Upload
                                </button>
                                <div class="clearfix"></div>
                             </div>
                         </div>
                     </div>
                 </div>
            </div>
            )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Account/Account.jsx